module.exports = __webpack_public_path__ + "static/media/emma_english_british.0ce9c446.mp3";